<article class="content-container">
  <div class="tabview-list space-evenly">
    <div [class.active]="tabIndex() === 0" (click)="wantsView('month')"><i class="mdi mdi-calendar-month-outline"></i> Month</div>
    <div [class.active]="tabIndex() === 1" (click)="wantsView('week')"><i class="mdi mdi-view-week-outline"></i> Week</div>
    <div></div>
  </div>

  <div class="mt-1 mb-1">
    <!--  <p-calendar appendTo="body" [inputStyle]="{ 'background-color': 'white', 'text-align': 'center', 'z-index': 1 }" #calendar (onSelect)="startAtChanged()" [minDate]="minimumDate" [maxDate]="maximumDate" [locale]="en" [dateFormat]="tabIndex() === 0 ? 'MM yy' : 'dd MM yy'" [(ngModel)]="startsAt" tabindex="0" [view]="tabIndex() === 0 ? 'month' : 'date'" [disabledDays]="tabIndex() === 0 ? [] : [0, 2, 3, 4, 5, 6]" readonlyInput="true"></p-calendar> -->
    @switch (tabIndex()) {
      @case (0) {
        <app-month-select [value]="startsAt" (onSelect)="startAtChanged($event)" [minDate]="minimumDate" [maxDate]="maximumDate" size="smaller" />
      }
      @case (1) {
        <app-calendar [value]="startsAt" (onSelectDate)="startAtChanged($event)" [disabledDays]="tabIndex() === 0 ? [] : [0, 2, 3, 4, 5, 6]" [minDate]="minimumDate" [maxDate]="maximumDate" size="small" cursorMode="week" />
      }
    }
  </div>
  <div class="menu">
    <div class="can-click" routerLink="/engage" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><span class="mdi mdi-home"></span> Home</div>
    <div class="can-click" routerLink="/engage/users" routerLinkActive="active"><span class="mdi mdi-account-group can-click"></span> Users</div>
  </div>
  <!--<div routerLink="/engage/config" routerLinkActive="active" class="mt-1"><span class="mdi mdi-cog-outline"></span> Config</div>-->
</article>
